/**
 * ⚠ DARK MODE ONLY. U+FE0E is the TEXT presentation selector; the light theme
 * keeps the original `'\u2714\uFE0F'` — heavy check mark plus the EMOJI
 * presentation selector — untouched.
 *
 * The difference matters because an emoji-presentation glyph is drawn from the
 * colour emoji font and ignores CSS `color` completely. In dark mode that left a
 * near-black tick on a dark row while the cell's own `color` was already the
 * right #BBBBBB, and no styling could lighten it. U+FE0E is the same character
 * drawn as an ordinary glyph in `currentColor`, so dark mode now inherits the
 * row's text colour — and can be tuned from CSS, which `.bullet-glyph` in
 * TableCard.vue then does.
 *
 * Written as an escape rather than the literal character on purpose: a bare
 * `'✔︎'` carries an INVISIBLE selector that an editor, a lint --fix or a careless
 * copy-paste can silently strip, which would put the emoji rendering back with
 * no visible diff.
 *
 * The off-state circles are emoji glyphs in both themes and are left alone.
 */
const ON_GLYPH_DARK = '\u2714\uFE0E'
const ON_GLYPH_LIGHT = '\u2714\uFE0F'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatNotFalseyAsBullet(
      val: string | undefined | null,
      isDarkMode?: boolean
    ): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatNotFalseyAsBullet = (
    val: string | undefined | null,
    isDarkMode = false
  ) => {
    // return !!val ? '🟣' : '⚪'
    const offIcon = isDarkMode ? '⚫' : '⚪'
    return val ? (isDarkMode ? ON_GLYPH_DARK : ON_GLYPH_LIGHT) : offIcon
  }
})
